import { Outlet } from "react-router-dom";
import { useIsMobile } from "@/hooks/use-mobile";
import Header from "@/components/navigation/Header";
import { usePageTitle } from "@/hooks/usePageTitle";
import BuyerSubscriptionBanner from "@/components/buyer/BuyerSubscriptionBanner";
import { PaymentFailedBanner } from "@/components/buyer/PaymentFailedBanner";
import { useBuyer } from "@/contexts/BuyerContext";
import { usePushNotifications } from "@/hooks/usePushNotifications";
import { useSafeAreaInsets } from "@/hooks/useSafeAreaInsets";
import { cn } from "@/lib/utils";

const BuyerLayout = () => {
  const isMobile = useIsMobile();
  const pageTitle = usePageTitle();
  const { buyerProfile } = useBuyer();
  const { isAndroid } = useSafeAreaInsets();
  
  // Initialize push notifications for buyers
  usePushNotifications({
    userId: buyerProfile?.user_id || null,
    userType: 'buyer',
    enabled: true
  });
  
  return (
    <div className="min-h-screen flex flex-col bg-[#080c14]">
      <PaymentFailedBanner />
      <BuyerSubscriptionBanner />
      <Header title={pageTitle} context="buyer" />
      
      <main className={cn(
        "flex-grow px-2 sm:px-4 md:px-6 2xl:px-8 max-w-7xl mx-auto w-full",
        isAndroid ? "pb-8" : "pb-[calc(2rem+env(safe-area-inset-bottom))]"
      )}>
        <div className="py-4">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default BuyerLayout;
